import React from 'react';
import { useTranslation } from 'react-i18next';
import Avatar from '../../../Units/Avatar';
import moment from 'moment';
import { getCurrentClubAdminAccount } from '../../../../store/selectors';
import { useSelector } from 'react-redux';
import parameters from '../../../../config/parameters';

const PlayerRowTransfer = ({ player, avatar, type, role }) => {
  const { t } = useTranslation();
  const adminAccount = useSelector(getCurrentClubAdminAccount);
  const playerRole =
    parameters.accountTypeIds[
      adminAccount && adminAccount.clubAccountId === player.playerId
        ? adminAccount.typeId
        : 1
    ];
  const positiveOrNegative = player.direction === 'claimedBack' ? '-' : '+';
  return (
    <div className={`playerTab`}>
      <div className={`avatarContainer`}>
        <Avatar data={avatar} />
        <div className={`roleContainer ${role || playerRole}`}>
          <p className={``}></p>
        </div>
      </div>
      <div className="clubInfo">
        <span className={`clubName`}>{player.applierName}</span>
        <p className={`id`}>
          {t('id')}: {player.applierId}
        </p>
        { type === 'tradeRecord' &&
          <span className={`nickname`}>
            <span className={`transferInfo`}>{t(`tradeDirection.${player.direction}`)}</span>
            <span className={`playername`}>{player.playerName}</span>
          </span>
        }
        {/* { type === 'grantCredit' ?
                    <span className={`nickname`}>
                        <span className={`transferInfo`}>{t.nickname}</span> 
                        <span className={`playername`}>{player.playerName}</span>
                    </span>
                :
                <span className={`nickname`}>
                    <span className={`transferInfo`}>{t.tradeDirection[player.direction]}</span> 
                    <span className={`playername`}>{player.playerName}</span>
                </span>
                } */}
      </div>
      <div className={`clubBalance`}>
        <React.Fragment>
          <div className={`transferAmount`}>
            <span
              className={`balanceNumber`}
            >{`${positiveOrNegative} ${player.amount}`}</span>
            <span className={`${player.currency}Icon`}></span>
          </div>
          <div className={`transaction`}>
            <span>{t(player.direction)}</span>
            <p>{moment(player.date).format('DD.MM.YY HH:mm')}</p>
          </div>
        </React.Fragment>
      </div>
    </div>
  );
};

export default PlayerRowTransfer;
